import { render, staticRenderFns } from "./PricesTypes.vue?vue&type=template&id=33721377"
import script from "./PricesTypes.vue?vue&type=script&lang=js"
export * from "./PricesTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports